export const APPLIED_LEAVES = 'leaveManagement@appliedLeaves';
export const USERS_ROLE_BASED = 'leaveManagement@usersRoleBased';

export default {
    [APPLIED_LEAVES]: {
        url: 'leave/get/all',
    },
    [USERS_ROLE_BASED]: {
        url: 'user/get/all-role-based',
    }
};
